import {
  IRecommendedProfessional,
  IRecommendedProfessionalApi,
} from './recommendedProfessionalsTypes';

function toRecommendedProfessionals(
  businessApi: IRecommendedProfessionalApi,
): IRecommendedProfessional {
  return {
    id: businessApi.id,
    profileImage: businessApi.profile_image,
    fullName: businessApi.fullname,
    professions: businessApi.professions,
    activityLevel: businessApi.activity_level,
    rating: businessApi.rating,
    loyaltyLevel: businessApi.loyalty_level,
    averageTimeManagement: businessApi.averageTimeManagement,
    averageInterpersonalSkills: businessApi.averageInterpersonalSkills,
    averageProfessionalSkills: businessApi.averageProfessionalSkills,
  };
}

export const recommendedProfessionalsAdapter = { toRecommendedProfessionals };
